import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { Router, Route } from '@angular/router';
//import { SubscriptionsearchClass } from '../Classes/SubscriptionsearchClass';
import { BackupDatabaseService } from '../Services/BackupDatabaseService';
import { CommonSearch } from '../Classes/CommonClass';
//import { IMyDpOptions } from 'mydatepicker';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Observable } from 'rxjs';

@Component({
  selector: 'Backupdatabase',
  templateUrl: '../BackupDatabase/BackupDatabase.component.html',
 styleUrls: ['../../Content/css/bootstrap.css', '../../Content/css/custom.css', '../../Content/css/master.css', '../../Content/css/innflow-top-menu.css',
    '../../Content/css/innflow-main.css', '../../Content/css/fixedheader.css'],
  providers: [BackupDatabaseService]
})

//export class logobj
//{
//  LogDateTime: string;
//  Logs: string;
//  //public string LogDateTime { get; set; }
//  //      public string Logs { get; set; }

//}

export class BackupDatabase implements OnInit {

  //_Subscription = new SubscriptionsearchClass();
  //_CommonSearch = new CommonSearch();
  innerWidth: number;
  tableRowWidth: number = 99;
  loading: boolean = false;
  Loaderimage: string = '../../assets/images/ajax-loader3.gif';
  listlog: any = [];

  //GetSubscriptionDetails: any = [];

  //public myDatePickerOptions: IMyDpOptions = {
  //  // other options...
  //  dateFormat: 'mm/dd/yyyy',
  //  height: '18px',
  //  width: '200px',
  //  selectionTxtFontSize: '12px',
  //  inline: false,
  //  selectorHeight: '218px',
  //  selectorWidth: '247px',
  //  openSelectorOnInputClick: true
  //};
  //SearchdropFirst: any[] = [
  //  { Value: 'Module', Text: 'Module' },
  //  { Value: 'TenantID', Text: 'TenantID' },
  //  { Value: 'OrgCode', Text: 'Org Code' },
  //  { Value: 'EntityCode', Text: 'Entity Code' },
  //  { Value: 'Status', Text: 'Status' },
  //  { Value: 'BillingStartDate', Text: 'Billing Start Date' },
  //  { Value: 'TerminationDate', Text: 'Termination Date' }
  //]
  //SearchdropSecond: any[] = [
  //  { Value: 'Module', Text: 'Module' },
  //  { Value: 'TenantID', Text: 'TenantID' },
  //  { Value: 'OrgCode', Text: 'Org Code' },
  //  { Value: 'EntityCode', Text: 'Entity Code' },
  //  { Value: 'Status', Text: 'Status' },
  //  { Value: 'BillingStartDate', Text: 'Billing Start Date' },
  //  { Value: 'TerminationDate', Text: 'Termination Date' }
  //]

  constructor(
    public backupDatabaseService: BackupDatabaseService,
    public toastr: ToastsManager,
    vcr: ViewContainerRef,
    public _router: Router
    
  )
  {
    this.toastr.setRootViewContainerRef(vcr);
    this.innerWidth = 100;
  }
  ngOnInit() {
    //// this.listlog =
    // this.loading = true;
    // this.GetDBLogs();
    // this.loading = false;
    //// this.GetDBBackupGrid();

    this.loading = true;
    this.backupDatabaseService.GetDBLogs().subscribe(data => {
      //let result = data;
      this.listlog = data;
      //console.log(data);
      //console.log(result);
      //alert(result.text);
      this.loading = false;
    }, err => {
      this.loading = false;
      alert(err);
      });

  }

  
  
  public TakeDBBackup() {
    //
    this.loading = true;
    this.backupDatabaseService.TakeBackup(sessionStorage.getItem('UserName')).subscribe(data => {
      let result = data;
      this.GetDBLogs();
      //console.log(result);
      alert(result.text);
      this.loading = false;
     // this.GetDBLogs();
    }, err => {
      this.loading = false;
      alert(err);
    });
  }

  public RestoreBackup() {
    //
    this.loading = true;
    this.backupDatabaseService.RestoreBackup(sessionStorage.getItem('UserName')).subscribe(data => {
      let result = data;
      this.GetDBLogs();
      //console.log(result);
      alert(result.text);
      this.loading = false;
      //this.GetDBLogs();
    }, err => {
      this.loading = false;
      alert(err);
    });
  }

  public GetDBLogs() {
    //
    //this.loading = true;
    this.backupDatabaseService.GetDBLogs().subscribe(data => {
      //let result = data;
      this.listlog = data;
      //console.log(data);
      //console.log(result);
      //alert(result.text);
      // this.loading = false;
    }, err => {
      //this.loading = false;
      alert(err);
    });
  }

  

  
}






// WEBPACK FOOTER //
// ./src/app/BackupDatabase/BackupDatabase.component.ts